$(document).ready(function () {
  let p = $("body").attr("p");
  let location_id = $("body").attr("location_id");

  if (p == "cash_holding" || p == "starting_cash_balance") {
    let start_date = $("#start_date").val();
    let end_date = $("#end_date").val();
    let order_by = $("#order_by").val();
    let order_by_direction = $("#order_by_direction").val();
    let page = $("#page").val();
    let location_id = $("body").attr("location_id");
    let cash_holding_ajax_lock = false;

    $(document).on("change", "#start_date, #end_date", function () {
      start_date = $("#start_date").val();
      end_date = $("#end_date").val();

      search();
    });

    $(document).on("click", ".sort", function () {
      order_by = $(this).prop("id");
      order_by_direction = $(this).data("order-direction");

      search();
    });

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      page = parseInt($(this).attr("href").substring(6));

      search();
    });

    $(document).on("click", "#export-cash-roundings", function (e) {
      e.preventDefault();

      const url = `/api/v1/private/cash-holding/download?start=${start_date}&end=${end_date}&location_id=${location_id}`;
      window.location.href = url;
    });

    $(document).on("submit", "#cash-setup-form", function (e) {
      e.preventDefault();
      const form = $(this);
      const formData = form.serialize();
      const location_id = form.find('[name="location_id"]').val();
      const organizer_id = form.find('[name="organizer_id"]').val();

      $.ajax({
        type: "POST",
        url: "/api/v1/private/cash-holding/start-balance-setup",
        data: formData,
      })
        .done(function (data) {
          const socketData = {
            type: "created_start_balance",
            location_id,
            organizer_id,
          };
          window.globalSocket.send(JSON.stringify(socketData));
          if (
            data.redirect_url !== undefined &&
            data.redirect_url != null &&
            data.redirect_url != ""
          ) {
            window.location.href = data.redirect_url;
          }
        })
        .fail(function (xhr) {
          if (
            xhr.responseJSON &&
            xhr.responseJSON.redirect_url !== undefined &&
            xhr.responseJSON.redirect_url != null &&
            xhr.responseJSON.redirect_url != ""
          ) {
            window.location.href = xhr.responseJSON.redirect_url;
          }
          alert("Kunne ikke lagre startsaldoen.");
        });
    });

    function search() {
      if (!cash_holding_ajax_lock) {
        cash_holding_ajax_lock = true;

        $.ajax({
          type: "POST",
          url: "/api/v1/private/cash-holding/search",
          data: {
            start_date,
            end_date,
            order_by,
            order_by_direction: order_by_direction.toUpperCase(),
            page,
            location_id,
          },
        })
          .done(function (data) {
            if (
              data.html != undefined &&
              data.html != null &&
              data.html != ""
            ) {
              $("#cash-holding-list").html(data.html);
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          })
          .always(function () {
            cash_holding_ajax_lock = false;
          });
      }
    }
  }
});
